import { styled } from 'baseui'
import { FlexCenter } from '@/shared/theme/styled-components'

export const StyledTitle = styled('h3', ({ $theme, $pulse }) => ({
  flexGrow: 1,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: 600,
  ...($pulse
    ? {
        fontSize: '14px',
        lineHeight: '20px',
        color: $theme.colors.textPulseStrong,
        paddingTop: '16px',
        marginBottom: '12px',
        borderTop: `1px solid ${$theme.colors.bgPulseTrack}`,
      }
    : {
        fontSize: '16px',
        letterSpacing: '-1.4%',
        color: $theme.colors.textHeading,
      }),
  height: 'auto',
}))

export const PulseSectionKicker = styled('h4', ({ $theme }) => ({
  marginTop: '4px',
  marginBottom: '12px',
  marginLeft: 0,
  marginRight: 0,
  paddingTop: '16px',
  borderTop: `1px solid ${$theme.colors.bgPulseTrack}`,
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 600,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: $theme.colors.textPulseMuted,
}))

export const addAddressButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      borderRadius: '.375rem',
      border: `1px solid ${$theme.colors.primaryAlt}`,
      backgroundColor: 'transparent',
      fontSize: '0.875rem',
      color: $theme.colors.primary400,
      textAlign: 'center',
      marginTop: '.5rem',
      ':hover': {
        backgroundColor: $theme.colors.primary400,
        color: $theme.colors.white,
      },
    }),
  },
}

export const pulseAddAddressButtonOverrides = {
  BaseButton: {
    style: {
      height: '36px',
    },
  },
}

export const CreateAddressButtonContainer = styled(FlexCenter, ({ $pulse }) =>
  $pulse
    ? { marginBottom: '16px' }
    : {
        height: '2rem',
        padding: '.25rem .75rem',
        gap: '.375rem',
        marginBottom: '1rem',
      },
)

export const MultipleInputsContainer = styled('div', () => ({
  display: 'flex',
  gap: '1rem',
}))
